import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {checkHasVerifiedPhone} from "../../../user/utils/check_has_verified_phone";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";
import {IApplicationMultiLeadProps} from "../../types/multi_lead/IApplicationMultiLeadProps";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/multi_lead/application_multi_lead_transform_to_data";
import {isRecommendationRecommendedProperty} from "../../utils/multi_lead/is_recommendation_recommended_property";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {useLeadData} from "../use_lead_data";
import {useLeadRequiredParams} from "../use_lead_required_params";
import {useMultiLeadReport} from "./use_multi_lead_report";
import {RecommendedOfferApplicationsType} from "./use_track_recommended_offers_application";

type IUseApplicationMultiLeadParams = Pick<
    IApplicationMultiLeadProps,
    "recommendationType" | "handleModalClose" | "handleSetMultiLeadSummaryStep" | "customGtmTracking"
>;

export const useApplicationMultiLead = (params: IUseApplicationMultiLeadParams) => {
    const {recommendationType, handleModalClose, handleSetMultiLeadSummaryStep, customGtmTracking} = params;

    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const currentViewType = useAppSelector((store) => store.viewType.current);
    const {modalClose: reportModalClose} = useMultiLeadReport(customGtmTracking);
    const originalApplication = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined}) ?? undefined;
    const multiLeadProperty = originalApplication?.property?.detail ?? null;
    const {data: userProfile} = useGetUserProfileQuery();
    const hasVerifiedPhone = checkHasVerifiedPhone(userProfile);

    const onSuccessfulSubmit = (applications: ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: hasVerifiedPhone && shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IApplicationMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = (totalOffers: number) => {
        reportModalClose(recommendationType, currentViewType, totalOffers);
        handleModalClose();
    };

    return {onSuccessfulSubmit, onCloseClick};
};
import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {checkHasVerifiedPhone} from "../../../user/utils/check_has_verified_phone";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";
import {IApplicationMultiLeadProps} from "../../types/multi_lead/IApplicationMultiLeadProps";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/multi_lead/application_multi_lead_transform_to_data";
import {isRecommendationRecommendedProperty} from "../../utils/multi_lead/is_recommendation_recommended_property";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {useLeadData} from "../use_lead_data";
import {useLeadRequiredParams} from "../use_lead_required_params";
import {useMultiLeadReport} from "./use_multi_lead_report";
import {RecommendedOfferApplicationsType} from "./use_track_recommended_offers_application";

type IUseApplicationMultiLeadParams = Pick<
    IApplicationMultiLeadProps,
    "recommendationType" | "handleModalClose" | "handleSetMultiLeadSummaryStep" | "customGtmTracking"
>;

export const useApplicationMultiLead = (params: IUseApplicationMultiLeadParams) => {
    const {recommendationType, handleModalClose, handleSetMultiLeadSummaryStep, customGtmTracking} = params;

    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const currentViewType = useAppSelector((store) => store.viewType.current);
    const {modalClose: reportModalClose} = useMultiLeadReport(customGtmTracking);
    const originalApplication = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined}) ?? undefined;
    const multiLeadProperty = originalApplication?.property?.detail ?? null;
    const {data: userProfile} = useGetUserProfileQuery();
    const hasVerifiedPhone = checkHasVerifiedPhone(userProfile);

    const onSuccessfulSubmit = (applications: ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: hasVerifiedPhone && shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IApplicationMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = (totalOffers: number) => {
        reportModalClose(recommendationType, currentViewType, totalOffers);
        handleModalClose();
    };

    return {onSuccessfulSubmit, onCloseClick};
};
